import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";
import type { WhatsAppStatus } from "./useWhatsApp";

export type ConnectWabaInput = {
  code: string;
  wabaId: string;
  phoneNumberId: string;
};

// Completes the Embedded Signup: posts the Meta authorization code + waba/phone ids to the backend,
// which exchanges the code and connects the client. Invalidates the status so the page flips to
// "connected" on success.
export function useConnectWaba() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: ConnectWabaInput) =>
      api.post<WhatsAppStatus>("/crm/whatsapp/waba/connect", input),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["whatsapp-status"] });
    },
  });
}
